import React from 'react';

// When adding a new integration:
//   1. Create the .mdx file in src/content/integrations/
//   2. Add an import and an entry to INTEGRATIONS below
//   3. scripts/seo-routes.js auto-discovers .mdx files from the filesystem,
//      so the sitemap + prerender list update without further changes.
import * as React_ from '../../content/integrations/react.mdx';
import * as Nextjs from '../../content/integrations/nextjs.mdx';
import * as Vue from '../../content/integrations/vue.mdx';
import * as Svelte from '../../content/integrations/svelte.mdx';
import * as Angular from '../../content/integrations/angular.mdx';
import * as Nuxt from '../../content/integrations/nuxt.mdx';
import * as Django from '../../content/integrations/django.mdx';
import * as Rails from '../../content/integrations/rails.mdx';
import * as Flutter from '../../content/integrations/flutter.mdx';
import * as ReactNative from '../../content/integrations/react-native.mdx';

interface IntegrationFrontmatter {
  title: string;
  description: string;
  framework: string;
  category: 'web' | 'mobile' | 'backend';
  icon?: string;
  ogImage?: string;
  draft?: boolean;
}

interface IntegrationModule {
  default: React.ComponentType;
  frontmatter: IntegrationFrontmatter;
}

export interface IntegrationEntry {
  slug: string;
  module: IntegrationModule;
}

const INTEGRATIONS: IntegrationEntry[] = [
  { slug: 'react', module: React_ as unknown as IntegrationModule },
  { slug: 'nextjs', module: Nextjs as unknown as IntegrationModule },
  { slug: 'vue', module: Vue as unknown as IntegrationModule },
  { slug: 'svelte', module: Svelte as unknown as IntegrationModule },
  { slug: 'angular', module: Angular as unknown as IntegrationModule },
  { slug: 'nuxt', module: Nuxt as unknown as IntegrationModule },
  { slug: 'django', module: Django as unknown as IntegrationModule },
  { slug: 'rails', module: Rails as unknown as IntegrationModule },
  { slug: 'flutter', module: Flutter as unknown as IntegrationModule },
  { slug: 'react-native', module: ReactNative as unknown as IntegrationModule },
];

let cached: IntegrationEntry[] | null = null;

export function listIntegrations(): IntegrationEntry[] {
  if (cached) return cached;
  cached = INTEGRATIONS.filter(e => e.module.frontmatter && !e.module.frontmatter.draft);
  return cached;
}

export function findIntegration(slug: string): IntegrationEntry | undefined {
  return listIntegrations().find(i => i.slug === slug);
}
